import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from './state/AppState';
import { App } from './App';
import { confirmLaunch } from './update/appUpdate';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('нет элемента #root');

// Подтверждаем, что приложение поднялось. Без этого обновление считается
// неудачным и при следующем запуске откатывается на встроенную сборку —
// защита от того, чтобы сломанная версия осталась у всех насовсем.
void confirmLaunch();

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AppProvider>
        <App />
      </AppProvider>
    </BrowserRouter>
  </StrictMode>,
);
